export default __webpack_public_path__ + "static/media/Logo_UK_27.89a0ffb4.png";